import { Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CreateReportExpenseFormData } from '../../models/reports/input';
import { Expenses, useReportStore } from '../../providers/ReportProvider';
import { CardBody } from '../Card';
import { NumberFormControl } from '../Form';
import { Section } from '../PropertyInformation';

export function PropertyExpenses() {
  const { setValue } = useFormContext<CreateReportExpenseFormData>();
  const { expenses } = useReportStore();

  useEffect(() => {
    if (expenses) {
      Object.keys(expenses).forEach((key) =>
        setValue(key as keyof Expenses, expenses[key as keyof Expenses])
      );
    }
  }, [setValue, expenses]);

  return (
    <Section>
      <CardBody>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/4">
            <NumberFormControl
              name="electricity"
              label="Electricity"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl name="internet" label="Internet" type="price" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl name="utilities" label="Utilities" type="price" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl name="gas" label="Gas" type="price" defaultValue={0} />
          </Stack>
        </div>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/4">
            <NumberFormControl name="hoaFees" label="HOA Fees" type="price" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="maintenance"
              label="Maintenance"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="capitalExpenditures"
              label="Capital Expenditures"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="managementFees"
              label="Management Fees"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
        </div>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/4">
            <NumberFormControl
              name="bookingPlatformFees"
              label="Booking Platform Fees"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="cleaningFees"
              label="Cleaning Fees"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl name="cleansPerMonth" label="Cleans per Month" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="landscaping"
              label="Landscaping"
              type="price"
              defaultValue={0}
            />
          </Stack>
        </div>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/4">
            <NumberFormControl
              name="snowRemoval"
              label="Snow Removal"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="pestControl"
              label="Pest Control"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl name="legalFees" label="Legal Fees" type="price" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="permitAndLicenseFees"
              label="Permits/License Fees"
              type="price"
              defaultValue={0}
            />
          </Stack>
        </div>
      </CardBody>
    </Section>
  );
}

export default PropertyExpenses;
